<style scoped>
	.checkin {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		padding: 16px 20px;
		box-sizing: border-box;
		background: #f4f7fc;
	}

	.checkin_title {
		font-size: 14px;
		color: #5c5c5c;
		margin-bottom: 10px;
	}

	.checkin_information_top {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.checkin_information {
		width: 100%;
		overflow-y: scroll;
		display: flex;
		flex: 1;
		flex-direction: column;
		box-sizing: border-box;
	}

	.checkin_information::-webkit-scrollbar {
		display: none;
	}

	.checkin_information_attendance_visitor {
		width: 380px;
		background: white;
		display: flex;
		flex-direction: column;
		box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
		border-radius: 6px 6px 6px 6px;
		margin-top: 30px;
	}

  .checkin_information_attendance {
    width: calc(100% - 420px);
    background: white;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
    border-radius: 6px 6px 6px 6px;
    margin-top: 30px;
  }

	.checkin_information_attendance_top {
		width: 100%;
		height: 69px;
		line-height: 69px;
		padding: 0 20px;
		color: rgba(0, 0, 0, 0.65);
		border-bottom: 1px solid #e8e8e8;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
	}

	.checkin_information_attendance_content {
		flex: 1;
		overflow-y: auto;
		width: 100%;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
    overflow: auto;
    max-height: calc(100vh - 550px);
	}
</style>

<template>
	<div class="checkin">
		<div class="checkin_title">首页</div>
		<div class="checkin_information">
			<div class="checkin_information_top">
				<information-card title="在职员工(人)" :value="employedUser" :icon="Icon1"></information-card>
				<information-card title="离职员工(人)" :value="leaveUser" :icon="Icon2"></information-card>
				<information-card title="在线设备(台)" :value="onlineDevice" :icon="Icon3"></information-card>
				<information-card title="离线设备(台)" :value="offlineDevice" :icon="Icon4"></information-card>
			</div>
			<div class="checkin_information_top" style="margin-top: 30px;">
				<information-card title="人员申请(待处理)" :value-style="{cursor: 'pointer'}" :value="applyUser" :icon="examinationIcon" @click="$router.replace('persionalApproval')"></information-card>
				<event-approval-card title="事件审批(待处理)" :value="eventApprovalList"></event-approval-card>
			</div>

      <div style="display: flex;justify-content: space-between ;height: 100%;">
        <div class="checkin_information_attendance_visitor">
          <div class="checkin_information_attendance_top">
            <div class="checkin_information_attendance_top_title">访客统计</div>
            <div>
              <i class="el-icon-refresh" style="font-size: 16px;cursor: pointer" @click="handleRereshVisitor"></i>
            </div>
          </div>
          <div class="checkin_information_attendance_content">
            <VisitorCard ref="visitorCardRef"/>
          </div>
        </div>
        <div class="checkin_information_attendance">
          <div class="checkin_information_attendance_top">
            <div class="checkin_information_attendance_top_title">常用功能</div>
            <div><el-button type="text" style="color:#409EFF" @click="handleCommonManage">新增</el-button></div>
          </div>
          <div class="checkin_information_attendance_content">
            <commonly-menu ref="commonlyMenuRef" @handleRemoveMenu="handleRemoveMenu" @handleAddMenu="handleCommonManage"/>
          </div>
        </div>
      </div>


			<company-footer-info />
		</div>

		<common-management-dialog ref="commonManagementDialog"
			@handleRemoveMenu="handleRemoveMenu" @handleAddMenu="handleAddMenu"></common-management-dialog>
	</div>

</template>


<script>
	import {BmsApplyApi} from "@/api/server/bmsApply";
	import {DmsDeviceApi} from "@/api/server/dmsDevice";
	import {countUser} from "@/api/server/umsUser";
	import {SysCommonlyMenuApi} from "@/api/server/sysCommonlyMenu";
	import CommonManagementDialog from "@/views/home/CommonManagementDialog.vue";
	import Icon1 from "@/assets/bulletin/icon1.png";
	import Icon2 from "@/assets/bulletin/icon2.png";
	import Icon3 from "@/assets/bulletin/icon3.png";
	import Icon4 from "@/assets/bulletin/icon4.png";
  import examinationIcon from "@/assets/structure/home/examination.png";
	import InformationCard from "@/components/InformationCard.vue";
	import EventApprovalCard from "@/views/home/compnents/EventApprovalCard.vue";
	import CommonlyMenu from "@/views/home/compnents/CommonlyMenu.vue";
	import CompanyFooterInfo from "@/components/companyFooterInfo.vue";
  import VisitorCard from "@/views/home/compnents/VisitorCard.vue";
	export default {
		components: {
			CompanyFooterInfo,
			InformationCard,
			EventApprovalCard,
			CommonlyMenu,
			CommonManagementDialog,
      VisitorCard
		},
		data() {
			return {
				Icon1: Icon1,
				Icon2: Icon2,
				Icon3: Icon3,
				Icon4: Icon4,
        examinationIcon: examinationIcon,
				//申请统计
				eventApprovalList: [],
				timer: '',
				//人员统计
				employedUser: 0,
				leaveUser: 0,
				applyUser: 0,
				//设备统计
				onlineDevice: 0,
				offlineDevice: 0,
				//菜单id集合
				menuIds: [],
			};
		},
		created() {

		},
		mounted() {
			this.setIntverData();
			this.getUserNum();
			this.getDeviceNum();
			this.getApplyNum();
			this.getFastMenu();
		},
		destroyed() {
      this.timer && clearInterval(this.timer);
		},
		methods: {
			setIntverData() {
				this.timer = setInterval(() => {
					this.getUserNum();
					this.getDeviceNum();
					this.getApplyNum();
				}, 30000)
			},
			//统计用户
			async getUserNum() {
				let {
					data
				} = await countUser();
				this.employedUser = data?.employedCount || 0;
				this.leaveUser = data?.leaveCount || 0;
				this.applyUser = data?.applyCount || 0;
			},
			//统计设备
			async getDeviceNum() {
				let {
					data
				} = await DmsDeviceApi.countDevice()
				this.onlineDevice = data?.onlineCount || 0;
				this.offlineDevice = data?.offlineCount || 0;
			},
			//统计申请
			async getApplyNum() {
				let {
					data
				} = await BmsApplyApi.countApply();
				let applyData = [{
						title: "加班申请",
						value: data?.overtimeCount  || 0,
						color: '#29CB97'
					},
					{
						title: "补班申请",
						value: data?.reissueCardCount || 0,
						color: '#EE7B32'
					}, {
						title: "请假申请",
						value: data?.leaveCount || 0,
						color: '#F0142F'
					}, {
						title: "出差申请",
						value: data?.evectionCount || 0,
						color: '#975FE5'
					}, {
						title: "外出申请",
						value: data?.goOutCount || 0,
						color: '#A09696'
					}, {
						title: "人脸申请",
						value: data?.faceCount || 0,
						color: '#0062FF'
					}
				]
				this.eventApprovalList = applyData;
			},
			//读取快捷菜单
			async getFastMenu(){
				let {data} = await SysCommonlyMenuApi.getCurrUserMenu();
				this.menuIds = data?.map(item => item.permissionId) || [];
				this.handleChangeMenu(this.menuIds);				
			},
			//移除菜单
			async handleRemoveMenu(menuId){
				await SysCommonlyMenuApi.deleteById(menuId);
				this.getFastMenu();
			},
			//新增菜单
			async handleAddMenu(menu){
				let param = {name:menu.title,permissionId: menu.id}
				await SysCommonlyMenuApi.insert(param);
				this.getFastMenu();
			},
			//打开新增
			handleCommonManage() {
				this.$refs.commonManagementDialog.show(this.menuIds);
			},
			//重新查询快捷菜单
			handleChangeMenu(selectedList) {
				this.$refs.commonlyMenuRef.handleChangeMenu(selectedList);
			},
      async handleRereshVisitor(){
        const res = await this.$refs?.visitorCardRef?.getData();
        if( res && res.code == 200){
          this.$message.success('刷新成功');
        }else{
          this.$message.error('刷新失败')
        }
      }
		}
	};
</script>